var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUpCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  opacity: 0,
  cx: 80,
  cy: 80,
  r: 50
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M80 0C35.82 0 0 35.82 0 80s35.82 80 80 80 80-35.82 80-80S124.18 0 80 0Zm38.67 96.62c-.91.88-2 1.31-3.28 1.31s-2.36-.44-3.23-1.31L80.28 64.7 47.8 97.18c-.91.88-2 1.31-3.28 1.31s-2.36-.44-3.23-1.31c-.87-.88-1.31-1.95-1.31-3.23s.44-2.36 1.31-3.23l35.44-35.44c1.19-1.19 2.38-1.78 3.56-1.78s2.17.39 2.95 1.17l35.44 35.44c.91.91 1.36 2 1.36 3.28s-.45 2.36-1.36 3.23Z"
})));

export default SvgUpCircle;